import React from 'react';
import { Statement } from './components/Statement';
import { TropicalBackground } from './components/TropicalBackground';
export function App() {
  return <div className="relative min-h-screen w-full overflow-hidden" data-id="element-0">
      <TropicalBackground data-id="element-1" />
      <Statement data-id="element-2" />
    </div>;
}